export const emptyDocumentPage = () => ({ value: '<p><br></p>', value_content: '', ids: [], new_ids: [], elements: [], heights: [], height: 0 });
export function initializeBlankDocument(component) {
    if (component._previewPagination) return component._previewPagination.then(() => initializeBlankDocument(component));
    component.pages_new = [emptyDocumentPage()];
    component.setState({ provaSelect: { id: '', questoes: [] }, pages: [], pages_new: component.pages_new, loading_page: false, readcontent: true, questoes_selecionadas: {}, numero_colunas: 1, numero_colunas_page: {} }, () => {
        const element = document.getElementById('page_content_0');
        if (element) element.innerHTML = component.pages_new[0].value;
    });
}
